import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";

import { Loader } from "@culturehq/components";
import ErrorMessage from "components/common/ErrorMessage";
import ProgressLine from "components/admin/analytics/ProgressLine";
import { CreatomateContext } from "../contexts/VideoStudioContext";

interface InteractivePlayerProps {
  isLoading: boolean;
  onSetupPlayer: (element: HTMLDivElement) => void;
  previewRef: React.MutableRefObject<Preview | undefined>;
}

const InteractivePlayer: React.FC<InteractivePlayerProps> = ({
  isLoading, onSetupPlayer, previewRef
}) => {
  const { data } = useContext(CreatomateContext);
  const { error, loading, progress } = data;

  return (
    <div className="Video-Player-Preview col-sm-8 p-0">
      {error && <ErrorMessage error={error} />}
      <div className="VideoPlayer">
        <div
          className="VideoPlayer-Iframe"
          ref={element => {
            if (element && element !== previewRef.current?.element) {
              onSetupPlayer(element);
            }
          }}
        />
        {(isLoading || loading) && <Loader loading />}
        {progress !== 0 && (
          <div className="LoaderContainer">
            <ProgressLine
              className="story-progressbar"
              color="#79b17d"
              valueNow={progress}
              valueMax={100}
            />
            <Loader loading />
          </div>
        )}
      </div>
    </div>
  );
};

export default InteractivePlayer;
